import React from "react";
import Transition from 'react-transition-group/Transition';
import styled from 'react-emotion';

const Wrapper = styled('div')`
  transition: opacity ${props => props.duration}ms ease-in-out;
  opacity: 0;
`;
 
 const transitionStyles = {
   entering: { opacity: 0 },
   entered:  { opacity: 1 },
   exiting:  { opacity: 1 },
   exited:   { opacity: 0 },
 };
 
 export const Fade = ({ in: inProp, children, duration = 100, appear, exit, ...rest }) => (
   <Transition in={inProp} timeout={duration} appear={appear} exit={exit}>
    {state => (
      <Wrapper duration={duration} style={transitionStyles[state]} {...rest}>
        {children}
      </Wrapper>
    )}
   </Transition>
 );


// WEBPACK FOOTER //
// ./src/components/Animations.jsx